export const HIDE_ANIMATION_TIME = 200;

export const ONBOARDING_MODAL = 'ONBOARDING_MODAL';
export const ONBOARDING_CREDITS_MODAL = 'ONBOARDING_CREDITS_MODAL';
export const TERMS_MODAL = 'TERMS_MODAL';

export const PURGE_ALL_MODAL = 'PURGE_ALL_MODAL';
export const PURGE_MODAL = 'PURGE_MODAL';
export const NEW_SAVED_SEARCH_MODAL = 'NEW_SAVED_SEARCH_MODAL';
export const SAVED_SEARCH_CHANGE_GROUP_MODAL =
  'SAVED_SEARCH_CHANGE_GROUP_MODAL';
export const SAVED_SEARCH_CLEAR_GROUP_MODAL = 'SAVED_SEARCH_CLEAR_GROUP_MODAL';
export const SAVED_SEARCH_EDIT_TITLE_MODAL = 'SAVED_SEARCH_EDIT_TITLE_MODAL';
export const SAVED_SEARCH_ACLS_MODAL = 'SAVED_SEARCH_ACLS_MODAL';
export const SAVED_SEARCH_DELETE_MODAL = 'SAVED_SEARCH_DELETE_MODAL';
export const SAVED_SEARCH_UPDATE_VALUES_MODAL =
  'SAVED_SEARCH_UPDATE_VALUES_MODAL';
export const SAVED_SEARCH_GROUP_EDIT_TITLE_MODAL =
  'SAVED_SEARCH_GROUP_EDIT_TITLE_MODAL';
export const SAVED_SEARCH_GROUP_DELETE_MODAL =
  'SAVED_SEARCH_GROUP_DELETE_MODAL';
export const SAVED_SEARCH_INFO_MODAL = 'SAVED_SEARCH_INFO_MODAL';
export const FILE_BROWSER_DELETE_MODAL = 'FILE_BROWSER_DELETE_MODAL';

export const FILE_BROWSER_TRANSFER_MODAL = 'FILE_BROWSER_TRANSFER_MODAL';
export const FORMATS_PANEL_TRANSFER_MODAL = 'FORMATS_PANEL_TRANSFER_MODAL';
export const FORMATS_PANEL_DELETE_FILESETS = 'FORMATS_PANEL_DELETE_FILESETS';
export const FORMATS_PANEL_DELETE_PROXY = 'FORMATS_PANEL_DELETE_PROXY';
export const FORMATS_PANEL_EDIT_SUBTITLES = 'FORMATS_PANEL_EDIT_SUBTITLES';
export const FORMATS_PANEL_FILESETS_FILES = 'FORMATS_PANEL_FILESETS_FILES';
export const FORMATS_PANEL_METADATA_MODAL = 'FORMATS_PANEL_METADATA_MODAL';
export const FORMATS_PANEL_NEW_FORMAT = 'FORMATS_PANEL_NEW_FORMAT';
export const CONFIRM_TRANSCODE = 'CONFIRM_TRANSCODE';
export const CONFIRM_PROXY = 'CONFIRM_PROXY';
export const SAVED_SEARCHES_PANEL_TRANSFER_MODAL =
  'SAVED_SEARCHES_PANEL_TRANSFER_MODAL';
export const COMMON_TRANSFER_MODAL = 'COMMON_TRANSFER_MODAL';
export const EXPORT_MODAL = 'EXPORT_MODAL';
export const NEW_SUBTITLE_MODAL = 'NEW_SUBTITLE_MODAL';
export const CONFIRM_TRANSCRIBE_SUBTITLE_MODAL =
  'CONFIRM_TRANSCRIBE_SUBTITLE_MODAL';

export const FORMATS_PANEL_ARCHIVE_MODAL = 'FORMATS_PANEL_ARCHIVE_MODAL';
export const SAVED_SEARCHES_PANEL_ARCHIVE_MODAL =
  'SAVED_SEARCHES_PANEL_ARCHIVE_MODAL';
export const COMMON_ARCHIVE_MODAL = 'COMMON_ARCHIVE_MODAL';

export const FORMATS_PANEL_RESTORE_MODAL = 'FORMATS_PANEL_RESTORE_MODAL';
export const SAVED_SEARCHES_PANEL_RESTORE_MODAL =
  'SAVED_SEARCHES_PANEL_RESTORE_MODAL';
export const COMMON_RESTORE_MODAL = 'COMMON_RESTORE_MODAL';

export const DELETE_ASSETS_MODAL = 'DELETE_ASSETS_MODAL';
export const DELETE_FILES_FROM_STORAGE_MODAL =
  'DELETE_FILES_FROM_STORAGE_MODAL';
export const DELETE_KEYFRAMES_MODAL = 'DELETE_KEYFRAMES_MODAL';
export const DELETE_MODAL = 'DELETE_MODAL';
export const DELETE_COLLECTION_MODAL = 'DELETE_COLLECTION_MODAL';
export const DELETE_WIDGETS_MODAL = 'DELETE_WIDGETS_MODAL';
export const DELETE_SHARES_MODAL = 'DELETE_SHARES_MODAL';
export const DELETE_SHARE_USERS_MODAL = 'DELETE_SHARE_USERS_MODAL';
export const DELETE_BULK_MODAL = 'DELETE_BULK_MODAL';
export const DELETE_APPLICATIONS_MODAL = 'DELETE_APPLICATIONS_MODAL';
export const DELETE_CUSTOM_ACTIONS_MODAL = 'DELETE_CUSTOM_ACTIONS_MODAL';
export const DELETE_EXPORT_LOCATIONS_MODAL = 'DELETE_EXPORT_LOCATIONS_MODAL';
export const DELETE_GROUPS_MODAL = 'DELETE_GROUPS_MODAL';
export const DELETE_TEAMS_MODAL = 'DELETE_TEAMS_MODAL';
export const DELETE_ROLE_GROUPS_MODAL = 'DELETE_ROLE_GROUPS_MODAL';
export const DELETE_JOBS_MODAL = 'DELETE_JOBS_MODAL';
export const DELETE_METADATA_VIEWS_MODAL = 'DELETE_METADATA_VIEWS_MODAL';
export const DELETE_RELATION_TYPES_MODAL = 'DELETE_RELATION_TYPES_MODAL';
export const DELETE_STORAGES_MODAL = 'DELETE_STORAGES_MODAL';
export const DELETE_TRANSCODERS_MODAL = 'DELETE_TRANSCODERS_MODAL';
export const DELETE_USERS_MODAL = 'DELETE_USERS_MODAL';
export const DELETE_WEBHOOKS_MODAL = 'DELETE_WEBHOOKS_MODAL';
export const REMOVE_FROM_COLLECTION_MODAL = 'REMOVE_FROM_COLLECTION_MODAL';
export const FAVORITES_REMOVE_ALL_MODAL = 'FAVORITES_REMOVE_ALL_MODAL';
export const CREATE_RELATION_MODAL = 'CREATE_RELATION_MODAL';
export const REVERSE_RELATION_CONFIRM_MODAL = 'REVERSE_RELATION_CONFIRM_MODAL';
export const ADD_TO_COLLECTION_MODAL = 'ADD_TO_COLLECTION_MODAL';
export const ADD_TO_COLLECTION_ADVANCED_MODAL =
  'ADD_TO_COLLECTION_ADVANCED_MODAL';
export const ADD_TO_PORTAL_MODAL = 'ADD_TO_PORTAL_MODAL';
export const CONFIRM_REMAP_COLLECTION = 'CONFIRM_REMAP_COLLECTION';
export const COLLECTION_INFO_MODAL = 'COLLECTION_INFO_MODAL';

export const ASSET_VERSION_DELETE_MODAL = 'ASSET_VERSION_DELETE_MODAL';
export const ASSET_VERSION_PROMOTE_MODAL = 'ASSET_VERSION_PROMOTE_MODAL';
export const ASSET_VERSIONS_CLEANUP_MODAL = 'ASSET_VERSIONS_CLEANUP_MODAL';
export const ASSET_VERSIONS_NEW_VERSION_SELECT_ASSET =
  'ASSET_VERSIONS_NEW_VERSION_SELECT_ASSET';
export const ASSET_VERSIONS_NEW_VERSION_FROM_NEW_FILE =
  'ASSET_VERSIONS_NEW_VERSION_FROM_NEW_FILE';
export const ASSET_VERSION_CONFIRM_UPLOAD = 'ASSET_VERSION_CONFIRM_UPLOAD';

export const TRANSCODER_CREATE_MODAL = 'TRANSCODER_CREATE_MODAL';
export const STORAGE_CREATE_MODAL = 'STORAGE_CREATE_MODAL';
export const GROUP_CREATE_MODAL = 'GROUP_CREATE_MODAL';
export const TEAM_CREATE_MODAL = 'TEAM_CREATE_MODAL';
export const ROLE_GROUP_CREATE_MODAL = 'ROLE_GROUP_CREATE_MODAL';
export const GROUP_ADD_USERS_MODAL = 'GROUP_ADD_USERS_MODAL';
export const TEAM_ADD_USERS_MODAL = 'TEAM_ADD_USERS_MODAL';
export const ROLE_GROUP_ADD_USERS_MODAL = 'ROLE_GROUP_ADD_USERS_MODAL';
export const TEAM_ADD_EDIT_MODAL = 'TEAM_ADD_EDIT_MODAL';
export const ROLE_GROUP_ADD_EDIT_MODAL = 'ROLE_GROUP_ADD_EDIT_MODAL';

export const USER_CREATE_MODAL = 'USER_CREATE_MODAL';

export const SHARE_MODAL = 'SHARE_MODAL';
export const SHARE_ACTIVITY_MODAL = 'SHARE_ACTIVITY_MODAL';
export const REVIEW_SHARE_MODAL = 'REVIEW_SHARE_MODAL';
export const SHARE_AUTHORIZE_EMAIL = 'SHARE_AUTHORIZE_EMAIL';

export const REVIEW_DELETE_REQUEST_MODAL = 'REVIEW_DELETE_REQUEST_MODAL';

export const ANALYZE_CONFIRM_MODAL = 'ANALYZE_CONFIRM_MODAL';
export const TRANSCRIBE_CONFIRM_MODAL = 'TRANSCRIBE_CONFIRM_MODAL';
export const RETRANSCODE_CONFIRM_MODAL = 'RETRANSCODE_CONFIRM_MODAL';
export const FACE_RECOGNITION_TRIGGER_CONFIRM_MODAL =
  'FACE_RECOGNITION_TRIGGER_CONFIRM_MODAL';

export const NEW_PLACEHOLDER_MODAL = 'NEW_PLACEHOLDER_MODAL';
export const NEW_CUTTING_ROOM_PROJECT_MODAL = 'NEW_CUTTING_ROOM_PROJECT_MODAL';

export const STORAGE_CONFIRM_CLEAR_MISSING_FILES =
  'STORAGE_CONFIRM_CLEAR_MISSING_FILES';
export const STORAGE_MARK_MISSING_OUTSIDE_SCANDIRS =
  'STORAGE_MARK_MISSING_OUTSIDE_SCANDIRS';

export const ADMIN_AI_DELETE_ACCOUNT = 'ADMIN_AI_DELETE_ACCOUNT';
export const ADMIN_AI_CREATE_ACCOUNT = 'ADMIN_AI_CREATE_ACCOUNT';

export const TRANSCRIPTIONS_EDIT_SUBTITLES = 'TRANSCRIPTIONS_EDIT_SUBTITLES';
export const TRANSCRIPTIONS_EDIT_SPEAKERS = 'TRANSCRIPTIONS_EDIT_SPEAKERS';
export const TRANSCRIPTIONS_CHANGE_SEGMENTS_SPEAKER =
  'TRANSCRIPTIONS_CHANGE_SEGMENTS_SPEAKER';
export const TRANSCRIPTIONS_CHANGE_WORDS_SPEAKER =
  'TRANSCRIPTIONS_CHANGE_WORDS_SPEAKER';

export const BILLING_ADD_CARD_MODAL = 'BILLING_ADD_CARD_MODAL';
export const BILLING_DELETE_CARD_MODAL = 'BILLING_DELETE_CARD_MODAL';

export const WEBHOOK_CREATE_EDIT_MODAL = 'WEBHOOK_CREATE_EDIT_MODAL';

export const APPLICATION_CREATE_EDIT_MODAL = 'APPLICATION_CREATE_EDIT_MODAL';

export const RELATION_TYPES_CREATE_EDIT_MODAL =
  'RELATION_TYPES_CREATE_EDIT_MODAL';

export const CUSTOM_ACTIONS_CREATE_EDIT_MODAL =
  'CUSTOM_ACTIONS_CREATE_EDIT_MODAL';
export const CUSTOM_ACTIONS_ACLS_MODAL = 'CUSTOM_ACTIONS_ACLS_MODAL';

export const PROFILE_CHANGE_PASSWORD = 'PROFILE_CHANGE_PASSWORD';

export const DELETE_COMMENT_MODAL = 'DELETE_COMMENT_MODAL';

export const DELETE_TIME_BASED_METADATA_MODAL =
  'DELETE_TIME_BASED_METADATA_MODAL';

export const JOBS_WIDGET_CREATE_EDIT_MODAL = 'JOBS_WIDGET_CREATE_EDIT_MODAL';
export const JOB_MODAL = 'JOB_MODAL';

export const UPLOADER_RENAME_FILE_MODAL = 'UPLOADER_RENAME_FILE_MODAL';
export const UPLOADER_RETRY = 'UPLOADER_RETRY';
export const UPLOADER_EDIT_METADATA_MODAL = 'UPLOADER_EDIT_METADATA_MODAL';
export const UPLOADER_FILES_METADATA_MODAL = 'UPLOADER_FILES_METADATA_MODAL';
export const UPLOADER_EDIT_TITLE_MODAL = 'UPLOADER_EDIT_TITLE_MODAL';
export const UPLOADER_CANCEL_UPLOAD_MODAL = 'UPLOADER_CANCEL_UPLOAD_MODAL';
export const UPLOADER_ACLS_MODAL = 'UPLOADER_ACLS_MODAL';
export const UPLOADER_ASSET_UPLOAD = 'UPLOADER_ASSET_UPLOAD';
export const UPLOADER_UPLOAD_STORAGE_MODAL = 'UPLOADER_UPLOAD_STORAGE_MODAL';
export const UPLOADER_STORAGE_CHANGE = 'UPLOADER_STORAGE_CHANGE';
export const UPLOADER_UPLOAD_FILE_INFO = 'UPLOADER_UPLOAD_FILE_INFO';
export const UPLOADER_CLEAR_WARNING = 'UPLOADER_CLEAR_WARNING';

export const EXPORT_LOCATIONS_ACLS_MODAL = 'EXPORT_LOCATIONS_ACLS_MODAL';
export const EXPORT_LOCATIONS_CREATE_EDIT_MODAL =
  'EXPORT_LOCATIONS_CREATE_EDIT_MODAL';

export const METADATA_VIEW_DUPLICATE_MODAL = 'METADATA_VIEW_DUPLICATE_MODAL';
export const METADATA_VIEW_CREATE_MODAL = 'METADATA_VIEW_CREATE_MODAL';
export const METADATA_VIEW_DELETE_MODAL = 'METADATA_VIEW_DELETE_MODAL';
export const METADATA_FIELD_DUPLICATE_MODAL = 'METADATA_FIELD_DUPLICATE_MODAL';
export const METADATA_FIELD_CREATE_EDIT_MODAL =
  'METADATA_FIELD_CREATE_EDIT_MODAL';
export const METADATA_FIELD_DELETE_MODAL = 'METADATA_FIELD_DELETE_MODAL';

export const METADATA_CATEGORY_CREATE_EDIT_MODAL =
  'METADATA_CATEGORY_CREATE_EDIT_MODAL';
export const METADATA_CATEGORY_DELETE_MODAL = 'METADATA_CATEGORY_DELETE_MODAL';

export const METADATA_MODAL = 'METADATA_MODAL';
export const METADATA_CUSTOM_ACTION_MODAL = 'METADATA_CUSTOM_ACTION_MODAL';

export const ADMIN_USERS_STATS_MODAL = 'ADMIN_USERS_STATS_MODAL';

export const SEARCH_DISPLAY_COLUMNS_MODAL = 'SEARCH_DISPLAY_COLUMNS_MODAL';

export const ACL_TEMPLATES_VIEW_CREATE_MODAL =
  'ACL_TEMPLATES_VIEW_CREATE_MODAL';
export const ACL_TEMPLATES_RENAME_MODAL = 'ACL_TEMPLATES_RENAME_MODAL';
export const ACL_TEMPLATES_DELETE_MODAL = 'ACL_TEMPLATES_DELETE_MODAL';
export const REMOVE_USER_AVATAR_MODAL = 'REMOVE_USER_AVATAR_MODAL';
export const REMOVE_GROUP_AVATAR_MODAL = 'REMOVE_GROUP_AVATAR_MODAL';
export const REMOVE_TEAM_AVATAR_MODAL = 'REMOVE_TEAM_AVATAR_MODAL';
export const REMOVE_SYSTEM_LOGO_MODAL = 'REMOVE_SYSTEM_LOGO_MODAL';

export const ENTITY_ACLS_MODAL = 'ENTITY_ACLS_MODAL';
export const ACLS_APPLY_TO_CONTENT = 'ACLS_APPLY_TO_CONTENT';
export const ACLS_DELETE_FROM_CONTENT = 'ACLS_DELETE_FROM_CONTENT';

export const AUTH_EXTERNAL_CONFIRM_MODAL = 'AUTH_EXTERNAL_CONFIRM_MODAL';
export const AUTH_EXTERNAL_SUCCESS_MODAL = 'AUTH_EXTERNAL_SUCCESS_MODAL';

export const IDENTITY_PROVIDERS_CREATE_MODAL =
  'IDENTITY_PROVIDERS_CREATE_MODAL';
export const IDENTITY_PROVIDERS_DELETE_MODAL =
  'IDENTITY_PROVIDERS_DELETE_MODAL';

export const COLLECTION_ORDER_CONFIRM_REMOVE =
  'COLLECTION_ORDER_CONFIRM_REMOVE';

export const SYSTEM_IP_ADDRESS_DELETE_MODAL = 'SYSTEM_IP_ADDRESS_DELETE_MODAL';
export const USER_IP_ADDRESS_DELETE_MODAL = 'USER_IP_ADDRESS_DELETE_MODAL';
export const GROUP_IP_ADDRESS_DELETE_MODAL = 'GROUP_IP_ADDRESS_DELETE_MODAL';
export const TEAM_IP_ADDRESS_DELETE_MODAL = 'TEAM_IP_ADDRESS_DELETE_MODAL';
export const SYSTEM_IP_ADDRESS_ADD_MODAL = 'SYSTEM_IP_ADDRESS_ADD_MODAL';
export const USER_IP_ADDRESS_ADD_MODAL = 'USER_IP_ADDRESS_ADD_MODAL';
export const GROUP_IP_ADDRESS_ADD_MODAL = 'GROUP_IP_ADDRESS_ADD_MODAL';
export const TEAM_IP_ADDRESS_ADD_MODAL = 'TEAM_IP_ADDRESS_ADD_MODAL';
export const NEW_COLLECTION_MODAL = 'NEW_COLLECTION_MODAL';
export const LINK_ASSET_MODAL = 'LINK_ASSET_MODAL';

export const STREAM_RECIPIENT_ADD_EDIT_MODAL =
  'STREAM_RECIPIENT_ADD_EDIT_MODAL';
export const STREAM_RECIPIENT_DELETE_MODAL = 'STREAM_RECIPIENT_DELETE_MODAL';

export const COMMENT_KEYFRAME_MODAL = 'COMMENT_KEYFRAME_MODAL';
export const SUBCLIP_CREATE_MODAL = 'SUBCLIP_CREATE_MODAL';
export const SUBCLIP_DELETE_MODAL = 'SUBCLIP_DELETE_MODAL';
export const FACE_CONFIRMATION_MODAL = 'FACE_CONFIRMATION_MODAL';
export const FACE_RECOGNITION_REMOVE_PERSON_MODAL =
  'FACE_RECOGNITION_REMOVE_PERSON_MODAL';
export const FACE_RECOGNITION_REMOVE_PERSON_INSTANCE_MODAL =
  'FACE_RECOGNITION_REMOVE_PERSON_INSTANCE_MODAL';
export const FACE_RECOGNITION_SELECT_PERSON_MODAL =
  'FACE_RECOGNITION_SELECT_PERSON_MODAL';
export const FACE_RECOGNITION_ADD_PERSON_MODAL =
  'FACE_RECOGNITION_ADD_PERSON_MODAL';
export const FACE_RECOGNITION_CHANGE_PERSON_MODAL =
  'FACE_RECOGNITION_CHANGE_PERSON_MODAL';
export const FACE_RECOGNITION_UNMATCH_PERSON_INSTANCE_MODAL =
  'FACE_RECOGNITION_UNMATCH_PERSON_INSTANCE_MODAL';
export const AUTOMATION_DELETE_MODAL = 'AUTOMATION_DELETE_MODAL';
export const AUTOMATION_DUPLICATE_MODAL = 'AUTOMATION_DUPLICATE_MODAL';
export const AUTOMATION_MODAL = 'AUTOMATION_MODAL';
export const AUTOMATION_RUN_MANUAL_MODAL = 'AUTOMATION_RUN_MANUAL_MODAL';
export const AUTOMATION_EDIT_TRIGGER_MODAL = 'AUTOMATION_EDIT_TRIGGER_MODAL';
export const AUTOMATION_EDIT_ACTION_MODAL = 'AUTOMATION_EDIT_ACTION_MODAL';
export const AUTOMATION_EDIT_SUMMARY_MODAL = 'AUTOMATION_EDIT_SUMMARY_MODAL';

export const APPROVE_REJECT_BULK_MODAL = 'APPROVE_REJECT_BULK_MODAL';
export const REINDEX_BULK_MODAL = 'REINDEX_BULK_MODAL';
export const ADMIN_SHARES_ADD_PARTICIPANT_MODAL =
  'ADMIN_SHARES_ADD_PARTICIPANT_MODAL';
export const NO_CREDITS_PAYWALL_MODAL = 'NO_CREDITS_PAYWALL_MODAL';
export const TRIAL_BILLING_CREDITS_MODAL = 'TRIAL_BILLING_CREDITS_MODAL';
export const BILLING_CREDITS_MODAL = 'BILLING_CREDITS_MODAL';
export const ADMIN_FACE_RECOGNITION_REMOVE_PERSON_MODAL =
  'ADMIN_FACE_RECOGNITION_REMOVE_PERSON_MODAL';
export const ASSET_LIMIT_MODAL = 'ASSET_LIMIT_MODAL';
export const TOTP_SETUP_MODAL = 'TOTP_SETUP_MODAL';
export const TOTP_DISABLE_MODAL = 'TOTP_DISABLE_MODAL';
export const MFA_DISABLE_MODAL = 'MFA_DISABLE_MODAL';

export const PLAYLIST_ITEM_DELETE_MODAL = 'PLAYLIST_ITEM_DELETE_MODAL';
export const PLAYLIST_ITEM_SELECT_MODAL = 'PLAYLIST_ITEM_SELECT_MODAL';

export const SAVE_SEARCH_VIEW_MODAL = 'SAVE_SEARCH_VIEW_MODAL';
export const EDIT_SEARCH_VIEW_MODAL = 'EDIT_SEARCH_VIEW_MODAL';
export const DELETE_SEARCH_VIEW_MODAL = 'DELETE_SEARCH_VIEW_MODAL';

export const CONFIRM_DELETE_INVITE_LINKS_MODAL =
  'CONFIRM_DELETE_INVITE_LINKS_MODAL';

export const AI_METADATA_MODAL = 'AI_METADATA_MODAL';
export const AI_METADATA_BULK_MODAL = 'AI_METADATA_BULK_MODAL';
export const AI_METADATA_REVIEW_MODAL = 'AI_METADATA_REVIEW_MODAL';
export const AI_METADATA_REVIEW_ALL_CONFIRM_MODAL =
  'AI_METADATA_REVIEW_ALL_CONFIRM_MODAL';
export const AI_TERMS_MODAL = 'AI_TERMS_MODAL';
export const AI_KILL_SWITCH_CONFIRM_MODAL = 'AI_KILL_SWITCH_CONFIRM_MODAL';
export const BILLING_AUTO_CREDITS_TOP_UP_MODAL =
  'BILLING_AUTO_CREDITS_TOP_UP_MODAL';
